import React from "react";

export const Flag = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28.319" height="42">
    <g
      data-name="Group 95"
      fill="none"
      stroke="#121212"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    >
      <path
        data-name="Path 293"
        d="M1 22.391V3.707h0c5.507-7.375 16.1 2.99 26.319 0-2.318 2.99-7.484 7.989-13.159 7.989 8.142 7.974 13.159 10.7 13.159 10.7v-.015c-10.214 2.99-20.812-7.375-26.319 0z"
      />
      <path data-name="Line 190" d="M1 7.807v33.192" />
    </g>
  </svg>
);

export const Blink = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28.017" height="28.006">
    <g
      data-name="Group 82"
      fill="none"
      stroke="#121212"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    >
      <g data-name="Group 79">
        <path data-name="Line 176" d="M14.459 20.287V7.717" />
        <path data-name="Line 177" d="M20.744 14.002H8.174" />
        <g data-name="Group 78">
          <path data-name="Line 178" d="M18.903 18.446l-8.888-8.888" />
          <path data-name="Line 179" d="M18.903 9.558l-8.888 8.888" />
        </g>
      </g>
      <path data-name="Line 180" d="M6.624 6.167L4.967 4.51" />
      <path data-name="Line 181" d="M23.482 23.026l-1.657-1.657" />
      <g data-name="Group 80">
        <path data-name="Line 182" d="M21.961 6.499l1.634-1.634" />
        <path data-name="Line 183" d="M5.336 23.125l1.634-1.634" />
      </g>
      <path data-name="Line 184" d="M14.458 3.327L14.457 1" />
      <path data-name="Line 185" d="M14.458 27.004l.005-2.327" />
      <g data-name="Group 81">
        <path data-name="Line 186" d="M24.684 14.058l2.327.016" />
        <path data-name="Line 187" d="M1.007 13.893l2.327.016" />
      </g>
    </g>
  </svg>
);

export const HandSmall = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28.001" height="27.818">
    <g
      data-name="Group 61"
      fill="none"
      stroke="#121212"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    >
      <path
        data-name="Path 232"
        d="M12.728 9.34l3.253-4.746a2.185 2.185 0 10-3.6-2.47L7.438 9.449"
      />
      <path
        data-name="Path 233"
        d="M15.696 13.709h9.121a2.185 2.185 0 100-4.369H12.7"
      />
      <path
        data-name="Path 234"
        d="M17.513 18.079a2.185 2.185 0 100-4.37h-2.628a2.185 2.185 0 000 4.37z"
      />
      <path
        data-name="Path 235"
        d="M17.513 22.449a2.185 2.185 0 100-4.37h-2.628a2.185 2.185 0 000 4.37z"
      />
      <path
        data-name="Path 236"
        d="M17.513 26.818a2.185 2.185 0 100-4.37h-2.628a2.185 2.185 0 000 4.37z"
      />
      <path
        data-name="Path 237"
        d="M14.886 26.818H9.321c-5.674 0-8.433-1.087-7.075-7.752"
      />
      <path
        data-name="Path 238"
        d="M2.646 19.067A5.274 5.274 0 011 15.231c0-3.848 3.216-5.891 6.433-5.782"
      />
    </g>
  </svg>
);

export const HandLarge = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="75.127" height="74.148">
    <g
      data-name="Group 61"
      fill="none"
      stroke="#d1e6fa"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
    >
      <path
        data-name="Path 232"
        d="M34.032 24.165L43.055 11a6.061 6.061 0 10-10-6.852L19.344 24.466"
      />
      <path
        data-name="Path 233"
        d="M42.266 36.285h25.3a6.06 6.06 0 000-12.12H33.955"
      />
      <path
        data-name="Path 234"
        d="M47.306 48.406a6.06 6.06 0 100-12.121h-7.291a6.06 6.06 0 000 12.121z"
      />
      <path
        data-name="Path 235"
        d="M47.306 60.527a6.061 6.061 0 100-12.121h-7.291a6.061 6.061 0 000 12.121z"
      />
      <path
        data-name="Path 236"
        d="M47.306 72.648a6.06 6.06 0 100-12.121h-7.291a6.06 6.06 0 000 12.121z"
      />
      <path
        data-name="Path 237"
        d="M40.015 72.648H24.577c-15.74 0-23.392-3.016-19.627-21.505"
      />
      <path
        data-name="Path 238"
        d="M6.066 51.146A14.629 14.629 0 011.5 40.505c0-10.674 8.922-16.34 17.844-16.039"
      />
    </g>
  </svg>
);

export const Snow = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="75.16" height="75.16">
    <g
      data-name="Group 60"
      fill="none"
      stroke="#d1e6fa"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
    >
      <path data-name="Line 121" d="M37.58 1.5v36.08" />
      <path
        data-name="Path 214"
        d="M49.898 11.435L37.58 21.995l-12.318-10.56"
      />
      <path data-name="Line 122" d="M37.58 73.66V37.58" />
      <path
        data-name="Path 215"
        d="M49.898 63.727L37.58 53.167l-12.318 10.56"
      />
      <path data-name="Line 123" d="M37.58 1.5v36.08" />
      <path data-name="Path 216" d="M25.262 11.435l12.318 10.56 12.318-10.56" />
      <path data-name="Line 124" d="M37.58 73.66V37.58" />
      <path data-name="Path 217" d="M25.262 63.727l12.318-10.56 12.318 10.56" />
      <path data-name="Line 125" d="M37.58 1.5v36.08" />
      <path
        data-name="Path 218"
        d="M49.898 11.435L37.58 21.995l-12.318-10.56"
      />
      <path data-name="Line 126" d="M37.58 73.66V37.58" />
      <path
        data-name="Path 219"
        d="M49.898 63.727L37.58 53.167l-12.318 10.56"
      />
      <path data-name="Line 127" d="M37.58 1.5v36.08" />
      <path data-name="Path 220" d="M25.262 11.435l12.318 10.56 12.318-10.56" />
      <path data-name="Line 128" d="M37.58 73.66V37.58" />
      <path data-name="Path 221" d="M25.262 63.727l12.318-10.56 12.318 10.56" />
      <path data-name="Line 129" d="M37.58 1.5v36.08" />
      <path
        data-name="Path 222"
        d="M49.898 11.435L37.58 21.995l-12.318-10.56"
      />
      <path data-name="Line 130" d="M37.58 73.66V37.58" />
      <path
        data-name="Path 223"
        d="M49.898 63.727L37.58 53.167l-12.318 10.56"
      />
      <path data-name="Line 131" d="M37.58 1.5v36.08" />
      <path data-name="Path 224" d="M25.262 11.435l12.318 10.56 12.318-10.56" />
      <path data-name="Line 132" d="M37.58 73.66V37.58" />
      <path data-name="Path 225" d="M25.262 63.727l12.318-10.56 12.318 10.56" />
      <path data-name="Line 133" d="M73.66 37.58H37.58" />
      <path data-name="Path 226" d="M63.727 25.262L53.167 37.58l10.56 12.318" />
      <path data-name="Line 134" d="M1.5 37.58h36.08" />
      <path data-name="Path 227" d="M11.435 25.262l10.56 12.318-10.56 12.318" />
      <path data-name="Line 135" d="M73.66 37.58H37.58" />
      <path data-name="Path 228" d="M63.727 49.898L53.167 37.58l10.56-12.318" />
      <path data-name="Line 136" d="M1.5 37.58h36.08" />
      <path data-name="Path 229" d="M11.435 49.898l10.56-12.318-10.56-12.318" />
      <path data-name="Line 137" d="M73.66 37.58H37.58" />
      <path data-name="Path 230" d="M63.727 25.262L53.167 37.58l10.56 12.318" />
      <path data-name="Line 138" d="M1.5 37.58h36.08" />
      <path data-name="Path 231" d="M11.435 25.262l10.56 12.318-10.56 12.318" />
      <path
        data-name="Rectangle 9"
        d="M37.58 26.886L48.274 37.58 37.58 48.275 26.886 37.58z"
      />
    </g>
  </svg>
);

export const Leaf = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="35.651" height="75.224">
    <g
      data-name="Group 75"
      fill="none"
      stroke="#d1e6fa"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
    >
      <path
        data-name="Path 258"
        d="M17.844 58.758c-8.8 0-15.915-3.924-15.915-19.748S11.497 7.869 17.844 1.5c6.347 6.369 15.915 21.686 15.915 37.51s-7.115 19.748-15.915 19.748"
      />
      <path data-name="Line 163" d="M17.825 1.5v72.224" />
      <path data-name="Line 164" d="M31.918 28.435L17.825 41.369" />
      <path data-name="Line 165" d="M3.732 28.435l14.093 12.934" />
      <g data-name="Group 73">
        <path data-name="Line 166" d="M33.531 35.904L17.825 50.318" />
        <path data-name="Line 167" d="M2.12 35.904l15.706 14.414" />
      </g>
      <g data-name="Group 74">
        <path data-name="Line 168" d="M30.107 21.322l-12.26 11.251" />
        <path data-name="Line 169" d="M5.544 21.282l12.303 11.291" />
      </g>
    </g>
  </svg>
);

export const Flower = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="34.124" height="75.515">
    <g
      data-name="Group 101"
      fill="none"
      stroke="#d1e6fa"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
    >
      <path data-name="Line 196" d="M17.083 36.108l-.038 37.905" />
      <path data-name="Line 197" d="M30.47 49.315L17.062 61.621" />
      <path data-name="Line 198" d="M3.654 49.315l13.408 12.306" />
      <g data-name="Group 100">
        <path data-name="Line 199" d="M32.004 56.422L17.062 70.136" />
        <path data-name="Line 200" d="M2.119 56.422l14.942 13.714" />
      </g>
      <path
        data-name="Path 298"
        d="M17.083 36.108c-8.369 0-15.142-3.733-15.142-18.788A43.681 43.681 0 013.605 5.704h0c2.59 3.172 6.739 6.423 6.739 13.058 0-6.635 4.106-14.09 6.7-17.262 2.591 3.172 6.781 10.627 6.781 17.262 0-6.635 4.148-9.886 6.739-13.058h0a43.721 43.721 0 011.663 11.616c0 15.055-6.772 18.788-15.141 18.788"
      />
    </g>
  </svg>
);

export const Sun = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="76.228" height="76.232">
    <g
      data-name="Group 68"
      transform="translate(-236.73 -614.553)"
      strokeWidth="3"
      stroke="#d1e6fa"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <circle
        data-name="Ellipse 4"
        cx="16.502"
        cy="16.502"
        r="16.502"
        transform="translate(258.326 636.181)"
      />
      <path data-name="Line 155" d="M310.809 616.706l-12.921 12.921" />
      <path data-name="Line 156" d="M251.776 675.739l-12.925 12.925" />
      <path data-name="Line 157" d="M310.837 688.633l-12.921-12.921" />
      <path data-name="Line 158" d="M251.804 629.6l-12.925-12.925" />
      <path data-name="Line 159" d="M310.836 652.683h-3.724" />
      <path data-name="Line 160" d="M242.255 652.683h-3.406" />
      <path data-name="Line 161" d="M274.829 688.664v-3.553" />
      <path data-name="Line 162" d="M274.829 620.255v-3.549" />
    </g>
  </svg>
);

export const Emblem = () => (
  <svg viewBox="0 0 514 232" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M365.145 232.32s5.871 0 3.319-5.285L260.028 2.355s-2.55-5.287-5.14-.02L144.729 226.373s-2.59 5.267 3.279 5.267h39.803s5.869 0 8.512-5.24l58.513-116.037s2.643-5.24 5.213.036l56.852 116.645s2.571 5.276 8.439 5.276z"
      fill="#2f57a8"
    />
    <path
      d="M220.985-.001s5.87 0 3.319 5.286L115.87 229.965s-2.55 5.286-5.141.02L.569 5.944S-2.02.68 3.85.68H43.65s5.87 0 8.512 5.24l58.514 116.037s2.642 5.24 5.213-.036L172.74 5.275s2.57-5.276 8.44-5.276zM510.055-.001s5.869 0 3.318 5.286L404.94 229.965s-2.551 5.286-5.14.02L289.639 5.944S287.048.68 292.917.68h39.803s5.87 0 8.512 5.24l58.515 116.037s2.641 5.24 5.212-.036l56.85-116.646s2.571-5.276 8.442-5.276z"
      fill="#2f57ab"
    />
    <path
      d="M227.27 190.328c0-16.217 13.146-29.361 29.363-29.361 16.216 0 29.364 13.144 29.364 29.36 0 16.217-13.148 29.365-29.364 29.365-16.217 0-29.364-13.148-29.364-29.364"
      fill="#2f57a8"
    />
  </svg>
);

export const Logo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="116.622" height="40.429">
    <g data-name="Group 3">
      <g data-name="Group 2" transform="translate(-14.799 -14.832)">
        <g data-name="Group 1">
          <path
            data-name="Path 1"
            d="M18.038 27.412a7.994 7.994 0 002.586 6.568c3.938 3.318 10.931 1.485 15.635-4.1 1.94-2.3 2.406-5.1 1.041-6.251s-4.044-.217-5.984 2.086c-4.7 5.583-5.325 12.785-1.387 16.1 3.086 2.6 9.037.6 13.306-4.462 1.761-2.09 2.321-4.514 1.251-5.416s-3.364.062-5.124 2.152c-4.269 5.066-5.227 11.269-2.141 13.869s9.823 1.809 14.062-3.667"
            fill="none"
            stroke="#040405"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="3"
          />
        </g>
        <circle
          data-name="Ellipse 1"
          cx="18.714"
          cy="18.714"
          r="18.714"
          transform="translate(16.299 16.332)"
          strokeWidth="3"
          stroke="#040405"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
      <path
        data-name="Path 2"
        d="M64.951 13.785a3.052 3.052 0 01-.065.6H59.88a1.673 1.673 0 00.414 1.171 1.335 1.335 0 00.957.356 1.308 1.308 0 00.815-.246 1.148 1.148 0 00.427-.634h2.338a3.06 3.06 0 01-.618 1.353 3.31 3.31 0 01-1.216.944 3.85 3.85 0 01-1.643.343 3.88 3.88 0 01-1.882-.446 3.189 3.189 0 01-1.287-1.284 3.994 3.994 0 01-.466-1.966 4.03 4.03 0 01.459-1.973 3.147 3.147 0 011.288-1.281 3.917 3.917 0 011.889-.446 3.916 3.916 0 011.889.44 3.107 3.107 0 011.261 1.235 3.678 3.678 0 01.446 1.834zm-2.238-.34a1.33 1.33 0 00-.382-1.067 1.4 1.4 0 00-.977-.356 1.449 1.449 0 00-1.009.363 1.517 1.517 0 00-.452 1.06zm7.762 4.14l-2.16-3.066v3.066h-2.213V8.012h2.212v5.252l2.16-2.9h2.6l-2.911 3.609 2.977 3.612zm6.844-7.309a4.059 4.059 0 011.921.446 3.272 3.272 0 011.333 1.287 3.866 3.866 0 01.485 1.966 3.866 3.866 0 01-.485 1.966 3.272 3.272 0 01-1.333 1.287 4.372 4.372 0 01-3.849 0 3.262 3.262 0 01-1.339-1.287 3.866 3.866 0 01-.485-1.966 3.866 3.866 0 01.485-1.966 3.262 3.262 0 011.339-1.287 4.1 4.1 0 011.928-.446zm0 1.915a1.41 1.41 0 00-1.067.459 1.86 1.86 0 00-.433 1.326 1.836 1.836 0 00.433 1.32 1.419 1.419 0 001.067.453 1.4 1.4 0 001.061-.453 1.854 1.854 0 00.427-1.32 1.878 1.878 0 00-.427-1.326 1.389 1.389 0 00-1.061-.46zM64.951 29.306a3.052 3.052 0 01-.065.6H59.88a1.673 1.673 0 00.414 1.171 1.335 1.335 0 00.957.356 1.308 1.308 0 00.815-.246 1.148 1.148 0 00.427-.634h2.338a3.06 3.06 0 01-.621 1.365 3.31 3.31 0 01-1.216.944 3.85 3.85 0 01-1.643.343 3.88 3.88 0 01-1.882-.446 3.189 3.189 0 01-1.284-1.293 4.425 4.425 0 01-.006-3.939 3.147 3.147 0 011.287-1.281 3.917 3.917 0 011.889-.446 3.916 3.916 0 011.889.44 3.107 3.107 0 011.261 1.235 3.678 3.678 0 01.446 1.831zm-2.238-.336a1.33 1.33 0 00-.382-1.068 1.4 1.4 0 00-.977-.356 1.449 1.449 0 00-1.009.362 1.517 1.517 0 00-.453 1.061zm7.762 4.14l-2.16-3.066v3.066h-2.213v-9.574h2.212v5.249l2.16-2.9h2.6l-2.911 3.609 2.975 3.609zm6.093-7.309a3.312 3.312 0 012.193.686 2.979 2.979 0 011.028 1.811h-2.07a1.147 1.147 0 00-.408-.692 1.238 1.238 0 00-.8-.252.87.87 0 00-.569.162.564.564 0 00-.194.459.539.539 0 00.356.5 5.673 5.673 0 001.119.336 11.113 11.113 0 011.358.395 2.241 2.241 0 01.919.653 1.805 1.805 0 01.388 1.216 1.865 1.865 0 01-.336 1.1 2.215 2.215 0 01-.97.75 3.791 3.791 0 01-1.5.272 3.864 3.864 0 01-2.342-.647 2.729 2.729 0 01-1.074-1.85h2.135a.961.961 0 00.395.712 1.486 1.486 0 00.886.246.825.825 0 00.569-.175.588.588 0 00.194-.459.552.552 0 00-.356-.537 6.541 6.541 0 00-1.158-.34 9.258 9.258 0 01-1.32-.362 2.179 2.179 0 01-.893-.627 1.748 1.748 0 01-.375-1.184 1.932 1.932 0 01.737-1.572 3.213 3.213 0 012.088-.602zm9.056 0a2.924 2.924 0 011.6.446 3.061 3.061 0 011.107 1.28 4.964 4.964 0 010 3.939 3.054 3.054 0 01-1.113 1.287 2.924 2.924 0 01-1.6.446 2.613 2.613 0 01-1.423-.375 2.179 2.179 0 01-.864-1.021v4.748h-2.209v-10.66h2.209v1.307a2.179 2.179 0 01.867-1.022 2.613 2.613 0 011.426-.376zm-.712 1.941a1.506 1.506 0 00-1.145.472 2.07 2.07 0 000 2.568 1.624 1.624 0 002.29.013 2.148 2.148 0 000-2.587 1.49 1.49 0 00-1.144-.467zm11.837 1.565a3.051 3.051 0 01-.065.6h-5.005a1.673 1.673 0 00.414 1.171 1.335 1.335 0 00.957.356 1.308 1.308 0 00.815-.246 1.148 1.148 0 00.427-.634h2.339a3.06 3.06 0 01-.621 1.365 3.31 3.31 0 01-1.216.944 4.153 4.153 0 01-3.525-.1 3.189 3.189 0 01-1.287-1.287 4.425 4.425 0 01-.006-3.939 3.147 3.147 0 011.287-1.281 4.247 4.247 0 013.778-.006 3.107 3.107 0 011.261 1.235 3.678 3.678 0 01.448 1.821zm-2.238-.336a1.33 1.33 0 00-.382-1.067 1.4 1.4 0 00-.977-.356 1.449 1.449 0 00-1.009.362 1.517 1.517 0 00-.453 1.061zm5.6-1.721a3.139 3.139 0 011.067-1.048 2.725 2.725 0 011.417-.388v2.371h-.634a2.186 2.186 0 00-1.365.375 1.507 1.507 0 00-.485 1.268v3.286h-2.21v-7.223h2.212zm7.5 3.959v1.9h-1a2.866 2.866 0 01-1.973-.627 2.66 2.66 0 01-.705-2.076v-2.653h-.97v-1.862h.97v-1.773h2.212v1.772h1.449v1.863h-1.439v2.691a.811.811 0 00.175.6.835.835 0 00.589.168zm5.33 0v1.9h-1a2.866 2.866 0 01-1.973-.627 2.66 2.66 0 01-.705-2.076v-2.653h-.97v-1.862h.97v-1.773h2.212v1.772h1.456v1.863h-1.446v2.691a.811.811 0 00.175.6.835.835 0 00.589.168zm1.035-7.348a1.08 1.08 0 01.362-.834 1.554 1.554 0 011.915 0 1.08 1.08 0 01.362.834 1.066 1.066 0 01-.362.821 1.554 1.554 0 01-1.915 0 1.066 1.066 0 01-.356-.823zm2.419 2.031v7.219h-2.206v-7.22z"
        fill="#040405"
      />
    </g>
  </svg>
);
